import React, { Component } from "react";
import { GridRow, GridColumn } from "arv-reactcomponents";
import { Anchor } from "arv-extends";
import { FOOTER } from "npmlinks-constants";

const { DELIVERY_OFFERS } = FOOTER;

class DeliveryOffers extends Component {
  componentDidMount() {
    console.log(this);
  }
  render() {
    return (
      <GridRow className="wc-footerdeliveryoffers">
        {DELIVERY_OFFERS.map(OFFER => (
          <GridColumn
            className={`${OFFER.CLASSNAME} wc-footerdeliveryoffers-item`}
          >
            <Anchor.component
              to={OFFER.URL}
              href={OFFER.URL}
              target="_self"
              className="wc-footerdeliveryoffers-anchor"
            >
              <i className={`wc-footerdeliveryoffers-icon ${OFFER.ICON}`} />
              <span className="wc-footerdeliveryoffers-anchorspan">
                {OFFER.TEXT}
              </span>
            </Anchor.component>
          </GridColumn>
        ))}
      </GridRow>
    );
  }
}

export default DeliveryOffers;
